module.exports = __webpack_public_path__ + "img/Orion.a1c3e3e1.png";